import { Outlet } from "react-router-dom";
import { Sidebar } from "./components/Sidebar";
import { TaskDetailPanel } from "./components/detail/TaskDetailPanel";
import { useUiStore } from "./state/uiStore";
import { useRealtimeSync } from "./lib/realtime";
import { useTheme } from "./hooks/useTheme";

export function App() {
  useRealtimeSync();
  useTheme();
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);
  const selectedTaskId = useUiStore((s) => s.selectedTaskId);

  return (
    <div className="shell">
      {collapsed ? (
        <button
          onClick={toggleSidebar}
          title="Déplier la sidebar"
          style={{
            position: "fixed",
            top: 12,
            left: 10,
            zIndex: 10,
            color: "var(--ink-ghost)",
            fontSize: 15,
            padding: "3px 6px",
            borderRadius: 6,
            background: "var(--bg-sidebar)",
            border: "1px solid var(--border)",
          }}
        >
          ››
        </button>
      ) : (
        <Sidebar />
      )}
      <main className="main">
        <Outlet />
      </main>
      {selectedTaskId && <TaskDetailPanel taskId={selectedTaskId} />}
    </div>
  );
}
